import React from "react";
import { Navigate, useParams } from "react-router-dom";

import { useUserRole } from "../../context/UserRoleContext";
import { useUserEmail } from "../../context/UserEmailContext";
import { useUserPermissions } from "../../context/UserPermissionsContext";
import { useAdviserStatus } from "../../context/AdviserStatusContext";
import { useAdminStatus } from "../../context/AdminStatusContext";

import PortalSectionPage from "./PortalSectionPage";
import { getPortalSectionConfig } from "./utils/portalSectionConfig";

const PortalSectionRouterPage = () => {
  const { sectionKey } = useParams();

  const { userRole } = useUserRole();
  const { userEmail } = useUserEmail();
  const { userPermissions = [] } = useUserPermissions();
  const { adviserStatus = [] } = useAdviserStatus();
  const { adminStatus = [] } = useAdminStatus();

  const configMap = getPortalSectionConfig({
    userRole,
    userEmail,
    userPermissions,
    adviserStatus,
    adminStatus,
  });

  const config = configMap[sectionKey];

  if (!config || !config.show) {
    return <Navigate to="/dashboard" replace />;
  }

  return <PortalSectionPage title={config.title} cards={config.cards || []} />;
};

export default PortalSectionRouterPage;
